import React from 'react';
import styles from '../Operations.module.css';

interface TSRUComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const TSRU: TSRUComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Round Up % of Transactions is calculated by taking the rolling 12 count of Round Up transactions (SKU 9269862) during campaign months (April, November, December) divided by the rolling 12 count of total transactions during campaign months. 
        <br /><br />
        Please note: This metric only applies to the Round Up SKU (9269862) when it&apos;s used for CMN Hospital fundraising and not for local Round Up efforts.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        To find out more about Round Up fundraising see the Ace Foundation page on AceNet or click here:
        <br />
        <a
          href="https://acenet.aceservices.com/about-ace/ace-foundation/round-up-for-kids"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Round Up for Kids (aceservices.com)
        </a>
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        40%
        <br /><br />
        <strong><u>Drilldown</u></strong>
        <br />
        Clicking the current value link will take you to a summary by month of Round Up transactions. You will be able to compare your store results to the company average. There are two drilldowns: Campaign Months and Non-Campaign Months. Campaign Months contribute to the overall metric while Non-Campaign Months do not. The yellow highlighting within each grid are the months contributing to the company average and store rolling 12 total. Ex. The Campaign Months drilldown will display April, November, and December in yellow.
        <br /><br />
        Multi-Store note: When in Multi-Store Mode (toggle switch at top of page), you will see each store&apos;s monthly performance.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Set up your system to Round Up during all campaigns. For set up instructions see Ace Way of Retailing{' '}
        <a
          href="https://acenet.aceservices.com/about-ace/ace-foundation/round-up-for-kids"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Children&apos;s Miracle Network (CMN) Charitable Donations Setup (aceservices.com)
        </a>
      </div>
    </div>
  );
};

TSRU.title = 'Children\'s Miracle Network (CMN) Fundraising – Round up transactions';
TSRU.actionTitle = 'Review By Month';
TSRU.actionHyperlink = 'dynamicURL:WFC:current';
export default TSRU;

